import { render, staticRenderFns } from "./BviButton.vue?vue&type=template&id=c5702cf2&scoped=true&"
import script from "./BviButton.vue?vue&type=script&lang=js&"
export * from "./BviButton.vue?vue&type=script&lang=js&"
import style0 from "./BviButton.vue?vue&type=style&index=0&id=c5702cf2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5702cf2",
  null
  
)

export default component.exports